import { theme } from '@zappyrent/hundop';
import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useToastContext } from '../../../contexts/ToastProvider';
import bookingsAPI from '../../../services/api/bookings';
import { IBooking } from '../../../shared/ts/booking';
import useStore from '../../../store';
import Modal from '../../Modal/Modal';
import ModalBody from '../../Modal/ModalBody/ModalBody';
import ModalContent from '../../Modal/ModalContent/ModalContent';
import ModalFooter from '../../Modal/ModalFooter/ModalFooter';
import ModalHeader from '../../Modal/ModalHeader/ModalHeader';
import {
  StyledBodyText,
  StyledButton,
  StyledButtonWrapper,
  StyledFlexWrapper,
  StyledSpinner,
} from './SendToAnlaysisModal.styles';

const SendToAnalysisModal = ({
  onClose,
  bookingId,
}: {
  onClose: () => void;
  bookingId: string;
  booking: IBooking | null;
}) => {
  const { t } = useTranslation(['documentsflow', 'common', 'booking', 'error']);
  const toast = useToastContext();
  const { user } = useStore(state => ({
    user: state.user,
  }));

  const { mutateAsync, isLoading } = useMutation(
    bookingsAPI.documentUploadedForBooking,
    {
      onSuccess: () => {
        toast.success(upperFirst(t('booking:documentsSuccessfullyUploaded')));
        onClose();
        window.location.href = process.env.REACT_APP_SITE_URL ?? '/';
      },
      onError: () => {
        window.location.href = process.env.REACT_APP_SITE_URL ?? '/';
        toast.error(upperFirst(t('error:error')));
      },
    },
  );

  const handleSendToAnalysis = () => {
    mutateAsync({ bookingId });
  };

  return (
    <Modal>
      <ModalBody>
        <ModalHeader
          title={upperFirst(t('documentsflow:sendToAnalysis'))}
          onClose={onClose}
        />
        <ModalContent>
          <StyledBodyText>
            {upperFirst(t('documentsflow:sendToAnalysisDescription'))}
          </StyledBodyText>
        </ModalContent>
        <ModalFooter>
          <StyledButtonWrapper>
            <br />
            <StyledFlexWrapper>
              <StyledButton
                user={user?.type ?? 'tenant'}
                variant="secondary"
                onClick={onClose}
              >
                {upperFirst(t('common:notNow'))}
              </StyledButton>
              <StyledButton
                user={user?.type ?? 'tenant'}
                onClick={handleSendToAnalysis}
                disabled={isLoading}
              >
                {isLoading && (
                  <StyledSpinner
                    foregroundColor={theme.colors.cross.ultralightGray}
                    size={15}
                    strokeSize={2}
                  />
                )}
                {upperFirst(t('common:yesSend'))}
              </StyledButton>
            </StyledFlexWrapper>
          </StyledButtonWrapper>
        </ModalFooter>
      </ModalBody>
    </Modal>
  );
};

export default SendToAnalysisModal;
